import styles from "./CheckoutForm.module.css";

export default function CheckoutReview({
  lines, shipping, payment, route, subtotal, formatAmount, error, submitting, onBack, onSubmit,
}) {
  return (
    <div className={styles.form}>
      <h2 className={styles.section}>Review Order</h2>

      <div className={styles.reviewBlocks}>
        <Block title="Ship To">
          <div>{shipping.name}</div>
          {shipping.company && <div>{shipping.company}</div>}
          <div>{shipping.address1}</div>
          {shipping.address2 && <div>{shipping.address2}</div>}
          <div>{shipping.city}, {shipping.state} {shipping.zip}</div>
          <div className={styles.muted}>{shipping.email} · {shipping.phone || "—"}</div>
          <div className={styles.muted}>Method: {shipping.method}</div>
        </Block>

        <Block title="Payment">
          {payment.mode === "po" ? (
            <>
              <div><strong>Purchase Order</strong></div>
              <div className={styles.muted}>PO #: {payment.poNumber || "—"}</div>
              {payment.notes && <div className={styles.muted}>Notes: {payment.notes}</div>}
            </>
          ) : (
            <div>Credit Card / Affirm — captured on submit.</div>
          )}
        </Block>
      </div>

      <h2 className={styles.section} style={{ marginTop: 28 }}>Line Items</h2>
      <ul className={styles.lineList}>
        {lines.map((l) => (
          <li key={l.sku} className={styles.lineItem}>
            <span className={styles.lineName}>{l.meta?.name || l.sku}</span>
            <span className={styles.lineQty}>× {l.qty}</span>
            <span className={styles.lineAmount}>{formatAmount(l.amount)}</span>
          </li>
        ))}
      </ul>
      <div className={styles.lineTotal}>
        <span>Subtotal</span><strong>{formatAmount(subtotal)}</strong>
      </div>

      {error && <div className={styles.error}>{error}</div>}

      <div className={styles.actions}>
        <button type="button" className={styles.back} onClick={onBack} disabled={submitting}>
          ← Payment
        </button>
        <button type="button" className={styles.next} onClick={onSubmit} disabled={submitting}>
          {submitting ? "Submitting…" :
           route === "po" ? "Submit Purchase Order" : "Place Order"}
        </button>
      </div>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <section className={styles.block}>
      <h3 className={styles.blockTitle}>{title}</h3>
      <div className={styles.blockBody}>{children}</div>
    </section>
  );
}
